import { Client, IMessage } from "@stomp/stompjs";
import { useEffect } from "react";
import SockJS from "sockjs-client";

const SOCKET_URL = `${process.env.REACT_APP_API_URL}:8061/ws`;

export function UseWebSocketSubscription(
  topics: string[] = [],
  onMessage: (topic: string, data: any) => void = () => { }
) {
  useEffect(() => {
    console.log(SOCKET_URL);
    const client = new Client({
      webSocketFactory: () => new SockJS(SOCKET_URL),
      reconnectDelay: 5000,
      onConnect: () => {
        console.log(`✅ Conectado al WebSocket: ${topics}`);

        topics.forEach((topic) => {
          client.subscribe(topic, (msg: IMessage) => {
            try {
              const data = JSON.parse(msg.body);
              onMessage(topic, data);
            } catch {
              onMessage(topic, msg.body);
            }
          });
        });
      },
      onStompError: (frame) => console.error("❌ STOMP Error:", frame.body),
      onWebSocketError: (evt) => console.error("❌ WebSocket Error:", evt),
    });

    client.activate();

    return () => {
      console.log("❌ Desmontando WebSocket, cerrando conexión...");
      client.deactivate(); // <-- esto es suficiente
    };

  }, [topics.join(","), onMessage]);
}

export default UseWebSocketSubscription;